import { HintType, TypeArray } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"

export type Hint = {
  type: HintType
  text: string
  video_id: string
}

const reducerAction = {
  type: actionCreatorTypeGuard<Hint, string>("type", "Hint"),
  text: actionCreatorTypeGuard<Hint, string>("text", "Hint"),
  video_id: actionCreatorTypeGuard<Hint, string>("video_id", "Hint"),
  __record: actionCreatorTypeGuard<TypeArray, Hint>("Hint", "__record"),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<Hint>>(
    "create",
    "__create/Hint"
  ),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof Hint
    | "__record"
    | "__delete"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const hintAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const hintReducer = reducerTypeGuard<Hint>()
  .case(...reducerAction.type)
  .case(...reducerAction.text)
  .case(...reducerAction.video_id)
  .build()
